// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .skip-to-content-link:focus {
    transform: translateY(0%);
  }




nav#navbar calcite-button {
    margin: 0;
}

nav#navbar h1 {
float: left; 
font-weight: 300;
font-size: clamp(12px, 1.5vw, 24px);
font-family: 'Segoe UI Light';
}




#navEnd {

    margin-left: auto;
    margin-right: clamp(5px, 1vw, 50px);
}

#navEnd span {
    margin-right: 5px;
}

#navEnd span, #navEnd calcite-button {
    font-size: clamp(10px, 1vw, 15px);

} 

nav#navbar calcite-button {
    margin-right: 5px;
}

nav#navbar calcite-button:hover {
    background-color: var(--calcite-color-brand-hover);
    cursor: pointer;
}

nav#navbar calcite-button:active {
    background-color: var(--calcite-color-brand-press);
}


@media (max-width: 500px) 
{  
    nav#navbar calcite-button {
        --calcite-color-brand-press: rgba(0, 0, 0, 0) !important;
        --calcite-color-brand-hover: rgba(0, 0, 0, 0) !important;
        --calcite-color-brand: rgba(0, 0, 0, 0) !important;
    }

    nav#navbar calcite-button {
        cursor: pointer;

        height: 50px;
        padding-left: 9px;
        padding-right: 9px;
        background-color: #2D5F85;
        max-height: 100%;
        margin-right: 2px;
    }
    nav#navbar calcite-button#releaseNotesButton {
        width: 10px;
        padding-left: 20px;
        padding-right: 20px;
    }

    #navEnd span {
        display: none;
    }
}



`, "",{"version":3,"sources":["webpack://./src/css/nav.css"],"names":[],"mappings":";;EAEE;IACE,yBAAyB;EAC3B;;;;;AAKF;IACI,SAAS;AACb;;AAEA;AACA,WAAW;AACX,gBAAgB;AAChB,mCAAmC;AACnC,6BAA6B;AAC7B;;;;;AAKA;;IAEI,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;;AAErC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,kDAAkD;AACtD;;;AAGA;;IAEI;QACI,wDAAwD;QACxD,wDAAwD;QACxD,kDAAkD;IACtD;;IAEA;QACI,eAAe;;QAEf,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["\r\n  \r\n  .skip-to-content-link:focus {\r\n    transform: translateY(0%);\r\n  }\r\n\r\n\r\n\r\n\r\nnav#navbar calcite-button {\r\n    margin: 0;\r\n}\r\n\r\nnav#navbar h1 {\r\nfloat: left; \r\nfont-weight: 300;\r\nfont-size: clamp(12px, 1.5vw, 24px);\r\nfont-family: 'Segoe UI Light';\r\n}\r\n\r\n\r\n\r\n\r\n#navEnd {\r\n\r\n    margin-left: auto;\r\n    margin-right: clamp(5px, 1vw, 50px);\r\n}\r\n\r\n#navEnd span {\r\n    margin-right: 5px;\r\n}\r\n\r\n#navEnd span, #navEnd calcite-button {\r\n    font-size: clamp(10px, 1vw, 15px);\r\n\r\n} \r\n\r\nnav#navbar calcite-button {\r\n    margin-right: 5px;\r\n}\r\n\r\nnav#navbar calcite-button:hover {\r\n    background-color: var(--calcite-color-brand-hover);\r\n    cursor: pointer;\r\n}\r\n\r\nnav#navbar calcite-button:active {\r\n    background-color: var(--calcite-color-brand-press);\r\n}\r\n\r\n\r\n@media (max-width: 500px) \r\n{  \r\n    nav#navbar calcite-button {\r\n        --calcite-color-brand-press: rgba(0, 0, 0, 0) !important;\r\n        --calcite-color-brand-hover: rgba(0, 0, 0, 0) !important;\r\n        --calcite-color-brand: rgba(0, 0, 0, 0) !important;\r\n    }\r\n\r\n    nav#navbar calcite-button {\r\n        cursor: pointer;\r\n\r\n        height: 50px;\r\n        padding-left: 9px;\r\n        padding-right: 9px;\r\n        background-color: #2D5F85;\r\n        max-height: 100%;\r\n        margin-right: 2px;\r\n    }\r\n    nav#navbar calcite-button#releaseNotesButton {\r\n        width: 10px;\r\n        padding-left: 20px;\r\n        padding-right: 20px;\r\n    }\r\n\r\n    #navEnd span {\r\n        display: none;\r\n    }\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
